import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login }    = useAuth();
  const navigate     = useNavigate();
  const [form, setForm]   = useState({ email:'', password:'' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const user = await login(form.email, form.password);
      navigate(user.role === 'admin' ? '/admin/dashboard' : '/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Check your email and password.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:24, background:'var(--bg)' }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ fontSize:48, marginBottom:12 }}>🏋️</div>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:26, fontWeight:700, color:'var(--text-primary)' }}>Fit to Fit</h1>
          <p style={{ color:'var(--text-secondary)', marginTop:4 }}>Sign in to your account</p>
        </div>

        <div className="card" style={{ padding:28 }}>
          {error && <div style={{ background:'var(--danger-dim)', border:'1px solid rgba(239,68,68,.25)', borderRadius:'var(--radius)', padding:'10px 14px', marginBottom:18, fontSize:13, color:'var(--danger)' }}>{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="label">Email address</label>
              <input className="input" type="email" placeholder="you@example.com" value={form.email}
                onChange={e => setForm(p => ({...p, email: e.target.value}))} required />
            </div>
            <div className="form-group">
              <label className="label">Password</label>
              <input className="input" type="password" placeholder="••••••••" value={form.password}
                onChange={e => setForm(p => ({...p, password: e.target.value}))} required />
            </div>
            <button className="btn-primary" type="submit" disabled={loading} style={{ width:'100%', justifyContent:'center', marginTop:4 }}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <p style={{ textAlign:'center', marginTop:18, fontSize:13, color:'var(--text-secondary)' }}>
            Not a member yet?{' '}
            <Link to="/register" style={{ color:'var(--accent)', fontWeight:500 }}>Register here</Link>
          </p>
        </div>

        <p style={{ textAlign:'center', marginTop:16, fontSize:12, color:'var(--text-muted)' }}>
          Admin? Use admin@fittofit.com / admin123
        </p>
      </div>
    </div>
  );
}
